import take from './take';
export default function toPromise(stream) {
    return new Promise((resolve, reject) => {
        let isComplete = false;
        let isAsync = false;
        const subscription = take(1, stream).subscribe({
            next(value) {
                resolve(value);
            },
            error(error) {
                reject(error);
            },
            complete() {
                resolve();
                isComplete = true;
                if (isAsync) {
                    subscription.unsubscribe();
                }
            },
        });
        if (isComplete) {
            subscription.unsubscribe();
        }
        isAsync = true;
    });
}
//# sourceMappingURL=to-promise.js.map